import tw, { styled } from 'twin.macro';

import { lightPanelStyles } from '../../util/floating';

export const StyledArrow = styled.div`
	${tw`absolute w-4 h-4`}
	z-index:-1;

	&:after {
		${tw`absolute w-4 h-4 transform rotate-45 bg-gray-900`}
		content: ' ';
	}
`;

/** `dark` (default): gray-900. `light`: the light panel of Popover content. */
export const StyledTooltip = styled.div<{ $variant: 'dark' | 'light' }>`
	${tw`px-3 py-1 rounded`}
	${({ $variant }) => ($variant === 'light' ? lightPanelStyles : tw`bg-gray-900`)}
	z-index: 555556;
`;
